// The duty form (views/duty/duty-edit.js). A new duty starts at 12 hours, rest break off, 10 minutes and no
// supervisor; editing a duty starts from what it has (duty/get gives duties.*: duration in minutes,
// rest_break, rest_time, rest_meter, supervisor_id), so a Save that changes only the time keeps the rest.

export const NEW_DUTY = {
	selectedDuration: { value: 12, label: '12 hours' },
	rest_break: false,
	selectedMinute: { value: 10, label: '10' },
	selectedMeter: { value: 10, label: '10' },
	supervisorId: null,
};

function whole(value) {
	const n = Number(value);
	return value !== null && value !== '' && typeof value !== 'boolean' && Number.isFinite(n) && n > 0 ? Math.round(n) : null;
}

function hoursLabel(hours) {
	return hours + (hours === 1 ? ' hour' : ' hours');
}

// The form's values for a stored duty; anything missing or unreadable falls back to the new-duty value
export function dutyFormValues(duty) {
	if (!duty || typeof duty !== 'object') {
		return { ...NEW_DUTY };
	}
	const minutes = whole(duty.duration);
	// A duration that is not whole hours is shown as it is, in hours (e.g. 7.5 hours), and saved unchanged
	const hours = minutes === null ? null : minutes / 60;
	const restTime = whole(duty.rest_time);
	const restMeter = whole(duty.rest_meter);
	const supervisor = whole(duty.supervisor_id);
	return {
		selectedDuration: hours === null ? NEW_DUTY.selectedDuration : { value: hours, label: hoursLabel(hours) },
		rest_break: duty.rest_break === true || duty.rest_break === 1 || duty.rest_break === '1' || duty.rest_break === 'true',
		selectedMinute: restTime === null ? NEW_DUTY.selectedMinute : { value: restTime, label: String(restTime) },
		selectedMeter: restMeter === null ? NEW_DUTY.selectedMeter : { value: restMeter, label: String(restMeter) },
		supervisorId: supervisor,
	};
}
